import { SpeedDial, SpeedDialAction, Typography, Fade } from '@mui/material';
import { MoreVert as MoreVertIcon } from '@mui/icons-material';

import React, { useEffect } from 'react';

export default function SpeedMenu({
  icon,
  open = false,
  actions = [],
  FabProps = {},
  defaultAction,
  onOpen = () => {},
  children,
  ...rest
}) {
  // const open = true;
  const [isOpen, setIsOpen] = React.useState(open);

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  return (
    <div id="speed-dial">
      <SpeedDial
        ariaLabel="Building actions"
        className="speed-dial"
        direction="up"
        icon={icon || defaultAction?.icon || <MoreVertIcon />}
        open={isOpen}
        FabProps={FabProps}
        classes={{
          fab: 'speed-dial-fab'
        }}
        onOpen={(event, reason) => {
          if (reason !== 'focus') onOpen();
          setIsOpen(true);
        }}
        onClose={() => {
          setIsOpen(false);
        }}
        onClick={event => {
          event.stopPropagation();
          setIsOpen(false);
          if (defaultAction?.onClick) defaultAction.onClick(event);
        }}
        {...rest}
      >
        {actions
          .filter(action => !action.isHidden)
          .map(action => (
            <SpeedDialAction
              tooltipTitle={
                <Typography style={{ whiteSpace: 'nowrap' }} variant="body1">
                  {action.tooltipTitle}
                </Typography>
              }
              key={action.tooltipTitle}
              classes={{
                staticTooltip: 'speed-dial-tooltip-label'
              }}
              icon={action.icon}
              tooltipOpen
              onClick={event => {
                event.stopPropagation();
                action.onClick(event);
              }}
            />
          ))}
      </SpeedDial>
      {defaultAction && (
        <Fade in={isOpen}>
          <Typography
            className="speed-dial-tooltip-label  default-action"
            variant="body1"
          >
            <span>{defaultAction.label}</span>
          </Typography>
        </Fade>
      )}

      {children}
    </div>
  );
}
